// extracted by mini-css-extract-plugin
module.exports = {"success":"var(--success, #2e872b)","danger":"var(--danger, #ca4a46)","warning":"var(--warning, #a46a1d)"};